import PasteOptionViewState from './store/schema/PasteOptionViewState';
import PasteOptionPlugin from './plugin/PasteOptionPlugin';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import createPasteOptionViewState from './utils/createPasteOptionViewState';
import pasteOptionPluginTrigger from './utils/pasteOptionPluginTrigger';
import { ComponentClass } from 'react';
export { ComponentClass };
import { LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "HtmlEditor" */ './lazyIndex'));

export type LazyPasteOptionPlugin = LazyPlugin<PasteOptionPlugin>;

export let LazyPasteOptionPluginClass = createLazyPlugin(
    lazyModule,
    m => m.PasteOptionPlugin,
    'PasteOption',
    pasteOptionPluginTrigger
);

// Types
export { LazyPlugin };

export { PasteOptionViewState, createPasteOptionViewState };
